










































































































































































































































































































import {
  defineComponent,
  reactive,
  Ref,
  onBeforeMount,
} from '@vue/composition-api'
import moment from 'moment'

import { IProgresses } from '@/types/log'
import { IUser, UserRole } from '@/types/user'
import { LogState } from '@/types/store'
import useVuex from '@/utils/useVuex'

type Props = {
  user: IUser
}
export default defineComponent({
  name: 'ProgressBoard',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const state = reactive<{
      isProgressesLoading: Ref<boolean>
      progresses: Ref<IProgresses>
    }>({
      isProgressesLoading: useVuex<LogState['isProgressesLoading']>(
        context,
        () => store.getters['log/isProgressesLoading'],
      ),
      progresses: useVuex<LogState['progresses']>(
        context,
        () => store.getters['log/progresses'],
      ),
    })

    onBeforeMount(() => {
      const payload = {
        date: moment().valueOf(),
        userRole: props.user.role,
        userId: props.user.id,
      }
      if (state.progresses.checked.today === -1) {
        store.dispatch('log/getProgresses', payload)
      } else {
        store.dispatch('log/getNewProgresses', payload)
      }
    })

    return { state, UserRole }
  },
})
